import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

client.interceptors.request.use((config) => {
  const token = localStorage.getItem("rl_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const publicApi = {
  list: (collection) => client.get(`/public/${collection}`).then((r) => r.data),
  pujaDetail: (id) => client.get(`/public/sankalp_pujas/${id}`).then((r) => r.data),
  settings: () => client.get(`/public/settings`).then((r) => r.data),
  lead: (payload) => client.post(`/public/lead`, payload).then((r) => r.data),
};

export const authApi = {
  login: (email, password) =>
    client.post(`/auth/login`, { email, password }).then((r) => r.data),
  me: () => client.get(`/auth/me`).then((r) => r.data),
};

export const adminApi = {
  list: (collection) => client.get(`/admin/${collection}`).then((r) => r.data),
  create: (collection, payload) =>
    client.post(`/admin/${collection}`, payload).then((r) => r.data),
  update: (collection, id, payload) =>
    client.put(`/admin/${collection}/${id}`, payload).then((r) => r.data),
  remove: (collection, id) =>
    client.delete(`/admin/${collection}/${id}`).then((r) => r.data),
  getSettings: () => client.get(`/admin/settings`).then((r) => r.data),
  updateSettings: (payload) =>
    client.put(`/admin/settings`, payload).then((r) => r.data),
  uploadFile: (file) => {
    const fd = new FormData();
    fd.append("file", file);
    return client
      .post(`/admin/upload`, fd, { headers: { "Content-Type": "multipart/form-data" } })
      .then((r) => r.data);
  },
};

/** Convert an /api/uploads/xxx or /uploads/xxx path to a full URL. */
export const toAbsoluteUrl = (url = "") => {
  if (!url) return "";
  if (url.startsWith("http")) return url;
  if (url.startsWith("/api/") || url.startsWith("/uploads")) return `${BACKEND_URL}${url}`;
  return url;
};

/** Return URL as-is. Rudralife.com images load fine from user's browser directly
 * (hotlink protection is not aggressive). The old backend proxy caused intermittent
 * 502 timeouts, so we skip it and let the browser handle image loading. */
export const proxied = (url = "") => url || "";

export default client;
